module.exports = __webpack_public_path__ + "img/1f_r_joy@2x.a8ae99e2.png";